import React from "react";
import MuiDivider from "@mui/material/Divider";

const Divider = (props) => {
  return <MuiDivider {...props} />;
};

Divider.propTypes = {};

export default Divider;
